<template>
  <Modal
    v-if="showPlanPopup"
    :active="showPlanPopup"
    :hide-exit="true"
    m-class="p-0 border-radius"
    @cancel="closeModal"
    @container="closeModal">
    <div class="bg-light2 modal-plan__container px-4 pt-3 pb-6">
      <div class="gp_modal-close p-1" @click="closeModal">
        <i class="icon icon-cancel"></i>
      </div>
      <div class="d-flex justify-content-center mb-3">
        <img class="modal-plan__img" :src="require('@/core/themes/icon/svg/unlock-features.svg')" alt="" />
      </div>
      <h4 class="heading-h4-18-semi text-light-high mb-2">Upgrade to unlock powerful feature</h4>
      <p class="paragraph-14-regular text-light-low mb-4">
        Whether you're just starting out or looking for scale, we've got features that fit.
      </p>
      <div class="clickable border-radius d-flex justify-content-center bg-primary-300 py-1" @click="redirectToPricing">
        <p class="body-14-medium txt-light-600">See Plan</p>
      </div>
    </div>
  </Modal>
</template>

<script>
import { mapState } from 'vuex';
import goToPricing from '@/mixins/goToPricing';

export default {
  name: 'PlanModal',
  mixins: [goToPricing],
  computed: {
    ...mapState('app', {
      showPlanPopup: 'showPlanPopup',
    }),
  },
  methods: {
    closeModal() {
      this.$store.commit('app/SHOW_PLAN_MODAL', false);
    },
    redirectToPricing() {
      this.closeModal();
      this.goToPricing();
    },
  },
};
</script>

<style lang="scss">
.modal-plan {
  &__container {
    width: 424px;
    position: relative;

    .icon-cancel {
      font-size: 16px;
    }
  }

  &__img {
    width: 113px;
  }
}
</style>
